export default {
  labels: {
    hide: 'Hide',
    show_order_summary: 'Show order summary',
  },
};
